import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

// Create rtl cache
const cacheRtl = createCache({
	key: "muirtl",
	stylisPlugins: [rtlPlugin],
});

export default function RTLProvider(props) {
	return <CacheProvider value={cacheRtl}>{props.children}</CacheProvider>;
}
